export default {
  data: () => ({
    uid: null
  }),
  mounted() {
    this.uid = this._uid
  }
}
